import immigration from "../assets/img/immigration.png";
import residence from "../assets/img/residence-location.png";
import workplace from "../assets/img/workplace.png";
import family from "../assets/img/family.png";
import immigrationlaw from "../assets/img/immigration-law.png";
import iccrc from "../assets/img/cicc.png";
import personalized from "../assets/img/personalization.png";
import ethical from "../assets/img/skills.png";
import diverse from "../assets/img/multitalented.png";
import ceoLogo from "../assets/img/owner.png";
import team2 from "../assets/img/secretary.png";
import itmanager from "../assets/img/itmanager.jpeg";

export const navigationLinks = [
  {
    id: "1",
    name: "About Us",
    url: "/about-us",
  },
  {
    id: "2",
    name: "Our Services",
    url: "/our-services",
  },
  {
    id: "3",
    name: "FAQ",
    url: "/faq",
  },
  {
    id: "4",
    name: "useful links",
    url: "/useful-links",
  },

  {
    id: "5",
    name: "Contact Us",
    url: "/contact-us",
  },
];

export const ourServiceLinks = [
  {
    id: "1",
    name: "immigration consultation",
    url: "/our-services",
  },
  {
    id: "2",
    name: "permanent residency",
    url: "/our-services",
  },
  {
    id: "3",
    name: "work permit and visas",
    url: "/our-services",
  },
  {
    id: "3",
    name: "family sponsorship",
    url: "/our-services",
  },
  {
    id: "3",
    name: "corporate immigration",
    url: "/our-services",
  },
];

export const faqData = {
  title: "FAQs",
  subtitle:
    "Below you'll find answers to some of the most common immigration-related questions, from choosing a visa type to filing refugee claims.",
  faqLinks: [
    {
      id: "general-immigration",
      name: "General Immigration"
    },
    {
      id: "visa-application",
      name: "Visa Application"
    },
    {
      id: "work-study",
      name: "Work & Study Visas"
    },
    {
      id: "citizenship-pr",
      name: "Citizenship & PR"
    },
    {
      id: "refugee-claims",
      name: "Refugee Claims"
    },
    {
      id: "common",
      name: "Other Common Questions"
    },
  ],
  faqGroups: [
    {
      title: "General Immigration Questions",
      faqs: [
        {
          id: 1,
          title: "What services does your immigration consultancy provide?",
          details:
            "We offer professional assistance with visa applications, permanent residency, work permits, student visas, business migration, citizenship applications, refugee claims, and appeals for visa refusals.",
          sectionID: "general-immigration",
        },
        {
          id: 2,
          title: "How do I know which visa type is right for me?",
          details:
            "The best visa option depends on factors such as your purpose of travel, qualifications, and financial status. Our experts can assess your eligibility and guide you in choosing the most suitable visa.",
          sectionID: "general-immigration",
        },
        {
          id: 3,
          title: "Do I need a consultant to apply for a visa?",
          details:
            "While you can apply on your own, immigration laws are complex and frequently changing. A consultant helps improve your chances of success by ensuring all requirements are met and avoiding costly mistakes.",
          sectionID: "general-immigration",
        },
      ],
    },
    {
      title: "Visa Application Process",
      faqs: [
        {
          id: 4,
          title: "How long does the visa application process take?",
          details:
            "Processing times vary based on the type of visa and the country you are applying to. Some visas take a few weeks, while others may take several months. We provide an estimated timeline based on the latest processing trends.",
          sectionID: "visa-application",
        },
        {
          id: 5,
          title: "What documents do I need for my visa application?",
          details:
            "Required documents vary by visa type, but generally include a valid passport, proof of funds, medical certificates, police clearance, educational certificates, and a letter of intent. We provide a customized document checklist.",
          sectionID: "visa-application",
        },
        {
          id: 6,
          title: "Can I apply for a visa if I have been previously refused?",
          details:
            "Yes, but it depends on the reason for the refusal. We can assess your case, address any weaknesses, and help you reapply with a stronger application.",
          sectionID: "visa-application",
        },
      ],
    },
    {
      title: "Work & Study Visas",
      faqs: [
        {
          id: 7,
          title: "Can I work while studying abroad?",
          details:
            "Many countries allow students to work part-time while studying. However, the number of hours you can work depends on the country's immigration rules.",
          sectionID: "work-study",
        },
        {
          id: 8,
          title: "How do I get a work visa?",
          details:
            "Work visas usually require a job offer from an employer in the destination country. We can help you find eligible opportunities and guide you through the application process.",
          sectionID: "work-study",
        },
        {
          id: 9,
          title: "What are the requirements for permanent residency?",
          details:
            "Permanent residency requirements vary by country but often include a specific number of years of legal stay, employment history, and contributions to the economy.",
          sectionID: "work-study",
        },
      ],
    },
    {
      title: "Citizenship & Permanent Residency",
      faqs: [
        {
          id: 10,
          title: "How can I become a citizen of another country?",
          details:
            "Citizenship can be obtained through naturalization, marriage, descent, or investment. We provide tailored guidance based on your eligibility.",
          sectionID: "citizenship-pr",
        },
        {
          id: 11,
          title: "What is the difference between permanent residency and citizenship?",
          details:
            "Permanent residency allows you to live and work indefinitely but does not grant a passport or voting rights. Citizenship provides full rights, including a passport and the ability to vote.",
          sectionID: "citizenship-pr",
        },
      ],
    },
    {
      title: "Refugee Claims (Ontario, Canada)",
      faqs: [
        {
          id: 12,
          title: "What is a refugee claim?",
          details:
            "A refugee claim is an application made by individuals seeking protection in Canada because they fear persecution, danger, or human rights violations in their home country.",
          sectionID: "refugee-claims",
        },
        {
          id: 13,
          title: "Who is eligible to make a refugee claim in Ontario?",
          details:
            "You may be eligible if you are in Canada and can prove that you face persecution based on race, religion, nationality, political opinion, or membership in a particular social group.",
          sectionID: "refugee-claims",
        },
        {
          id: 14,
          title: "How do I apply for refugee status in Ontario?",
          details:
            "You can submit your claim at a port of entry (airport, land border) or an inland Immigration, Refugees, and Citizenship Canada (IRCC) office. We assist in preparing your claim, gathering supporting documents, and representing you in hearings.",
          sectionID: "refugee-claims",
        },
        {
          id: 15,
          title: "What happens after I submit my refugee claim?",
          details:
            "Your claim will be reviewed by the Immigration and Refugee Board (IRB), and you may be scheduled for a hearing. While waiting, you may be eligible for a work permit, healthcare, and social services in Ontario.",
          sectionID: "refugee-claims",
        },
      ],
    },
    {
      title: "Other Common Questions",
      faqs: [
        {
          id: 16,
          title: "Do you guarantee visa approval?",
          details:
            "No consultancy can guarantee visa approval, as decisions are made by the immigration authorities. However, we maximize your chances by ensuring a complete and well-prepared application.",
          sectionID: "common",
        },
        {
          id: 17,
          title: "Can you help with visa refusals and appeals?",
          details:
            "Yes, we analyze your rejection reasons and assist in filing an appeal or reapplying with a stronger case.",
          sectionID: "common",
        },
        {
          id: 18,
          title: "Do you assist with family sponsorship?",
          details:
            "Yes, we help individuals sponsor their family members for visas, permanent residency, and citizenship.",
          sectionID: "common",
        },
        {
          id: 19,
          title: "How much do your services cost?",
          details:
            "Our fees vary depending on the type of service required. Contact us for a personalized quote.",
          sectionID: "common",
        },
      ],
    },
  ]

};


export const serviceCardContent = [
  {
    id: "0",
    heading: "Immigration Hearings",
    body: "Our experienced team represents clients in immigration hearings, ensuring every case is presented thoroughly and in compliance with Canadian immigration law.",
    url: "/our-services",
    icon: immigration,
  },
  {
    id: "1",
    heading: "Immigration Appeals",
    body: "We assist clients in appealing adverse immigration decisions, meticulously preparing each case to secure a favorable outcome.",
    url: "/our-services",
    icon: immigrationlaw,
  },
  {
    id: "2",
    heading: "Refugee Claims / Hearings",
    body: "Providing expert representation in refugee claims and hearings, we advocate passionately for individuals seeking protection and asylum in Canada.",
    url: "/our-services",
    icon: residence,
  },
  {
    id: "3",
    heading: "Detention Reviews",
    body: "Our legal experts work diligently to ensure that clients' rights are upheld during detention proceedings through comprehensive detention reviews.",
    url: "/our-services",
    icon: workplace,
  },
  {
    id: "4",
    heading: "Deportation Order Cases",
    body: "We offer comprehensive support for individuals facing deportation orders, challenging decisions and protecting our clients' interests at every step.",
    url: "/our-services",
    icon: family,
  },
  {
    id: "5",
    heading: "Pre-Removal Risk Assessment (PRRA) Cases",
    body: "We guide clients through the PRRA process—assessing risks prior to removal from Canada and advocating for those in vulnerable situations.",
    url: "/our-services",
    icon: immigration,
  },
  {
    id: "6",
    heading: "Family Class Sponsorships (In-Canada & Overseas)",
    body: "Facilitating family reunification, we streamline both in-Canada and overseas family sponsorship applications with compassion and efficiency.",
    url: "/our-services",
    icon: family,
  },
  {
    id: "7",
    heading: "Humanitarian & Compassionate Cases",
    body: "Our compassionate legal team handles humanitarian and compassionate cases, ensuring that unique circumstances receive the consideration they deserve.",
    url: "/our-services",
    icon: workplace,
  },
  {
    id: "8",
    heading: "Work & Study Permit Extensions",
    body: "We assist clients in extending their work and study permits, ensuring timely renewals and compliance with Canadian immigration regulations.",
    url: "/our-services",
    icon: family,
  },
  {
    id: "9",
    heading: "Visitor's Record Extension",
    body: "Our experts provide tailored support for extending visitor records, allowing clients to remain in Canada legally beyond their initial stay.",
    url: "/our-services",
    icon: family,
  },
  {
    id: "10",
    heading: "Applications from Inside Canada",
    body: "We offer comprehensive guidance for immigration applications submitted from within Canada, ensuring all domestic requirements are met.",
    url: "/our-services",
    icon: family,
  },
  {
    id: "11",
    heading: "Federal Skilled Worker Applications",
    body: "Our dedicated team assists skilled professionals through the Federal Skilled Worker program, preparing robust applications for permanent residency.",
    url: "/our-services",
    icon: family
  },
  {
    id: "12",
    heading: "Canadian Experience Class Applications",
    body: "We specialize in guiding candidates with Canadian work experience through the Canadian Experience Class pathway to secure permanent residency.",
    url: "/our-services",
    icon: immigrationlaw,
  },
  {
    id: "13",
    heading: "Provincial Nominee Applications",
    body: "Our experts help clients navigate the Provincial Nominee Program, ensuring a smooth application process and increasing the likelihood of a nomination.",
    url: "/our-services",
    icon: residence,
  },
];

export const whatWeDo = [
  {
    id: "0",
    title: "CICC Accreditation",
    desc: "Bansah and Associates is registered with CICC, ensuring our clients receive advice and representation from qualified professionals.",
    icon: iccrc,
    count: 100
  },
  {
    id: "1",
    title: "Personalized Service",
    desc: "Our client-centric approach ensures that each client receives individualized attention, working",
    icon: personalized,
    count: 100
  },
  {
    id: "2",
    title: "Ethical Practices",
    desc: "Integrity remains at the core of our firm. We uphold the highest ethical standards, ensuring transparency",
    icon: ethical,
    count: 100
  },
  {
    id: "3",
    title: "Diverse Expertise",
    desc: "Mr. Edward Bansah's diverse background, from working in the U.S. to his journey in Canada, provides",
    icon: diverse,
    count: 90
  }
]

export const aboutContent = {
  title: "Our Founder",
  desc: "Mr. Edward Bansah is the founder of Bansah & Associates, a trusted immigration consultancy firm dedicated to helping individuals and families navigate the complexities of immigration processes. With a strong commitment to excellence and integrity, he has built a reputation for providing expert guidance and personalized solutions tailored to each client's unique needs. As a licensed immigration consultant, Mr. Bansah is authorized to practice in Canada and with the main office in Toronto and a branch in Calgary, Alberta. His extensive knowledge of immigration laws and policies, combined with years of experience, enables him to assist clients with visa applications, permanent residency, citizenship, and other immigration-related matters. At Bansah & Associates, Mr. Bansah leads a team of professionals who share his passion for delivering reliable, efficient, and ethical immigration services. His goal is to simplify the immigration process, ensuring that clients receive the best possible support on their journey to Canada. At With a deep understanding of immigration pathways and a dedication to client success, Mr. Edward Bansah continues to make a meaningful impact in the field, helping individuals achieve their dreams of living and working in Canada.",
}


export const whyChooseUsContent = {
  title: "Why Choose Bansah and Associates?",
  points: [
    {
      title: "ICCRC Accreditation",
      description: "Bansah and Associates is proud to be a Regulated Canadian Immigration Consultant registered with ICCRC, ensuring our clients receive advice and representation from qualified professionals."
    },
    {
      title: "Personalized Service",
      description: "Our client-centric approach ensures that each client receives individualized attention, working collaboratively to tailor solutions that align with their unique goals and circumstances."
    },
    {
      title: "Ethical Practices",
      description: "Integrity remains at the core of our firm. We uphold the highest ethical standards, ensuring transparency and honesty throughout the immigration process."
    },
    {
      title: "Diverse Expertise",
      description: "Mr. Edward Bansah's diverse background, from working in the U.S. to his journey in Canada, provides a wealth of experience that sets our firm apart in understanding the challenges and aspirations of our clients."
    }
  ]
};

export const team = [
  {
    name: "Edward Bansah",
    position: "Founder & Principal Consultant",
    img: ceoLogo,
  },
  {
    name: "Dorcas Obeng-Asante",
    position: "Associate",
    img: team2,
  },
  {
    name: "Prince Oti A.",
    position: "IT Manager",
    img: itmanager,
  },
];

export const usefulLinksData = {
  title: "Useful Links",
  description: "Below are some resources from Immigration, Refugees and Citizenship Canada (IRCC) that can assist immigrants and those looking to apply for their family members:",
  links: [
    {
      title: "Immigrate to Canada",
      url: "https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada.html",
      description: "Explore various immigration programs to move to Canada. Find out how to apply, check your eligibility, and learn about programs like Express Entry, family sponsorship, and more."
    },
    {
      title: "Sponsor your family members",
      url: "https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/family-sponsorship.html",
      description: "Learn how to sponsor eligible family members, such as your spouse, partner, dependent children, parents, or grandparents, to become permanent residents of Canada."
    },
    {
      title: "Check processing times",
      url: "https://www.canada.ca/en/immigration-refugees-citizenship/services/application/check-processing-times.html",
      description: "Find out how long it will take IRCC to process your application, including those for permanent residence, temporary residence, citizenship, and more."
    },
    {
      title: "Find immigration and citizenship forms",
      url: "https://www.canada.ca/en/immigration-refugees-citizenship/services/application.html",
      description: "Access all the necessary forms for applying to immigrate, sponsor family members, extend your stay, and other related services."
    },
    {
      title: "Express Entry: Immigrate as a skilled worker",
      url: "https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/express-entry.html",
      description: "Learn about the Express Entry system, which manages applications for permanent residence from skilled workers."
    },
    {
      title: "Provincial Nominee Program",
      url: "https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/provincial-nominees.html",
      description: "Discover how to be nominated by a Canadian province or territory for permanent residence based on your skills and work experience."
    },
    {
      title: "Find out if you need a visa",
      url: "https://www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada/entry-requirements-country.html",
      description: "Determine if you need a visa or an Electronic Travel Authorization (eTA) to visit or transit through Canada."
    },
    {
      title: "Apply for a visitor visa",
      url: "https://www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada/apply.html",
      description: "Learn how to apply for a visitor visa (tourist visa) to come to Canada."
    },
    {
      title: "Apply for permanent residence: Spouses and partners",
      url: "https://www.canada.ca/en/immigration-refugees-citizenship/services/application/application-forms-guides/apply-permanent-residence-spouse-partner.html",
      description: "Guidelines on how to apply for permanent residence if you're sponsoring your spouse or partner."
    },
    {
      title: "Apply for permanent residence: Parents and grandparents",
      url: "https://www.canada.ca/en/immigration-refugees-citizenship/services/application/application-forms-guides/apply-permanent-residence-parents-grandparents.html",
      description:
        "Information on how to sponsor your parents and grandparents for permanent residence in Canada.",
    },
  ],
  note: "These resources should provide comprehensive information to assist you and your family members in navigating the Canadian immigration process."
};

export const contactPageData = {
  title: "Contact Us",
  address: {
    street: "1111 Albion Rd",
    city: "Etobicoke",
    province: "ON",
    postalCode: "M9V 1A9",
    country: "Canada"
  },
  contactInfo: {
    phone: "+1 416-785-0522",
    email: "info@bansahandassociates.com"
  },
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d92247.07362635227!2d-79.6483877896559!3d43.737121402358056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x882b3a86a828cb2f%3A0x951ee6012c4beab5!2s1111%20Albion%20Rd%2C%20Etobicoke%2C%20ON%20M9V%201A9%2C%20Canada!3m2!1d43.737151!2d-79.5659871!5e0!3m2!1sen!2sgh!4v1702050665595!5m2!1sen!2sgh"
};
